import { UseEvent, UseUser, UsePhoneVerification, UseAlert, UseVerification } from './index';
import { i18n, useTranslation } from '../helpers/i18n';

export default function UseSignIn() {
  const event = UseEvent();
  const { keepAlive, updateBalance } = UseUser();
  const phoneVerification = UsePhoneVerification();
  const verification = UseVerification()
  const alert = UseAlert();
  const {t} = useTranslation()

  const open = (params = {}) => {
    event.emit("lb-event", {
      type: "SignIn",
      ...params,
      /*onSuccess: (e) => {
        keepAlive().then((res) => {
          if(params.onSuccess) params.onSuccess(res);


          if (res.data.mobile_verified === "no") {
            phoneVerification.open({
              onSuccess: () => {
                alert.open({ message: t('თქვენი ნომერი ვერიფიცირებულია') });              },
            });
          }
        });
      },*/
      onCancel: params?.onCancel ? (e) => params.onCancel(e) : null,
    });
  };

  return { open };
}
